import { createFileRoute } from "@tanstack/react-router";
import { useAuth } from "@/hooks/useAuth";
import { ProProfilePanel } from "@/components/pro-profile-panel";
import { OffersPanel } from "@/components/offers-panel";
import { privatePageMetadata } from "@/lib/seo";

export const Route = createFileRoute("/app/pro")({
  head: () =>
    privatePageMetadata(
      "/app/pro",
      "Professional profile | BeHot.Now",
      "Manage your professional profile.",
    ),
  component: ProDashboard,
});

function ProDashboard() {
  const { user } = useAuth();
  return (
    <div className="max-w-3xl space-y-8">
      <ProProfilePanel userId={user?.id} />
      <OffersPanel userId={user?.id} />
    </div>
  );
}
